/** High-level capability chips from permissions manifest. */

export function buildCapabilityChips(manifest) {
  if (!manifest) return []

  const tools = new Set(manifest.enabled_tools ?? [])
  const chips = []

  if (manifest.wiki_access) {
    chips.push({ id: 'wiki', label: 'Wiki', active: true })
  }

  const hasDocs =
    tools.has('search_knowledge') ||
    tools.has('get_document') ||
    tools.has('analyze_evidence') ||
    tools.has('knowledge_query') ||
    tools.has('list_sources')
  if (hasDocs) {
    chips.push({ id: 'documents', label: 'Documents', active: true })
  }

  if (tools.has('knowledge_query')) {
    chips.push({ id: 'query', label: 'Knowledge query', active: true })
  }

  if (manifest.personal_kb_available) {
    chips.push({ id: 'personal', label: 'Personal', active: true })
  }

  const sourceCount = manifest.searchable_sources?.length ?? 0
  if (sourceCount > 0) {
    chips.push({
      id: 'sources',
      label: `${sourceCount} source${sourceCount === 1 ? '' : 's'}`,
      active: true,
    })
  }

  return chips
}
